import { memo, useMemo, useState } from "react";
import dayjs from "dayjs";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import PendingTaskCard from "@coworker/apprestructured/src/task-management/components/TaskCard/variants/PendingTaskCard/PendingTaskCard";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import ListableTaskCardWrapper from "@coworker/apprestructured/src/task-management/components/TaskCard/wrappers/NormalTaskWrapper/ListableTaskCardWrapper";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";
import { DatePicker } from "@coworker/apprestructured/src/shared/components/DatePicker/DatePicker";
import Start from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Start/Start";

function PendingTaskCardDemo() {
  const [taskType, setTaskType] = useState("Custom task");
  const [priority, setPriority] = useState(true);
  const [assigned, setAssigned] = useState("John Lovén");
  const [date, setDate] = useState("Created 2025-10-16");
  const [start, setStart] = useState<string | null>(
    dayjs().add(1, "day").format("YYYY-MM-DD")
  );
  const [loadingTaskType, setLoadingTaskType] = useState(false);
  const [loadingPriority, setLoadingPriority] = useState(false);
  const [loadingAssigned, setLoadingAssigned] = useState(false);
  const [loadingDate, setLoadingDate] = useState(false);
  const [loadingStart, setLoadingStart] = useState(false);

  const startElement = useMemo(() => {
    return start ? <Start date={start} /> : null;
  }, [start]);

  return (
    <Demo>
      <Name>PendingTaskCard (listable)</Name>
      <Highlight>
        <ListableTaskCardWrapper>
          <PendingTaskCard
            taskType={loadingTaskType ? LOADING : taskType}
            priority={loadingPriority ? LOADING : priority}
            assigned={loadingAssigned ? LOADING : assigned}
            date={loadingDate ? LOADING : date}
            startElement={loadingStart ? LOADING : startElement}
          >
            fragments
          </PendingTaskCard>
        </ListableTaskCardWrapper>
      </Highlight>
      <Actions>
        <FixaInputField
          label="taskType"
          type="text"
          id="pendingtaskcarddemo-taskType"
          value={taskType}
          onChange={(e) => setTaskType(e.target.value)}
        />
        <FixaInputField
          label="assigned"
          type="text"
          id="pendingtaskcarddemo-assigned"
          value={assigned}
          onChange={(e) => setAssigned(e.target.value)}
        />
        <FixaInputField
          label="date"
          type="text"
          id="pendingtaskcarddemo-date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <FixaCheckbox
          id="pendingtaskcarddemo-priority"
          label="priority"
          checked={priority}
          value="pendingtaskcarddemo-priority"
          onChange={() => setPriority((prev) => !prev)}
        />
        <DatePicker value={start} onChange={setStart} label="start" />
        <FixaCheckbox
          id="pendingtaskcarddemo-loadingTaskType"
          label="loadingTaskType"
          checked={loadingTaskType}
          value="pendingtaskcarddemo-loadingTaskType"
          onChange={() => setLoadingTaskType((prev) => !prev)}
        />
        <FixaCheckbox
          id="pendingtaskcarddemo-loadingAssigned"
          label="loadingAssigned"
          checked={loadingAssigned}
          value="pendingtaskcarddemo-loadingAssigned"
          onChange={() => setLoadingAssigned((prev) => !prev)}
        />
        <FixaCheckbox
          id="pendingtaskcarddemo-loadingDate"
          label="loadingDate"
          checked={loadingDate}
          value="pendingtaskcarddemo-loadingDate"
          onChange={() => setLoadingDate((prev) => !prev)}
        />
        <FixaCheckbox
          id="pendingtaskcarddemo-loadingPriority"
          label="loadingPriority"
          checked={loadingPriority}
          value="pendingtaskcarddemo-loadingPriority"
          onChange={() => setLoadingPriority((prev) => !prev)}
        />
        <FixaCheckbox
          id="pendingtaskcarddemo-loadingStart"
          label="loadingStart"
          checked={loadingStart}
          value="pendingtaskcarddemo-loadingStart"
          onChange={() => setLoadingStart((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(PendingTaskCardDemo);
